import EmptyState from './EmptyState';

const NoEmail = () => {
  return (
    <EmptyState
      title="No People"
      subtitle="Select or Write an Email to View People"
    />
  );
};

export default NoEmail;
